import { render, staticRenderFns } from "./SettingTable.vue?vue&type=template&id=15bc159e&scoped=true&"
import script from "./SettingTable.vue?vue&type=script&lang=js&"
export * from "./SettingTable.vue?vue&type=script&lang=js&"
import style0 from "./SettingTable.vue?vue&type=style&index=0&id=15bc159e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bc159e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VSimpleTable,VSwitch,VTextField})
